<template>
	<div style="margin-top: 50px; text-align: center;">
		<div style="font-size: 200px; font-weight: bold;">404</div>
		<div style="font-size: 30px;">Страница не существует</div>
	</div>
</template>

<style lang="css" scoped>

</style>

<script>
export default {
	name: 'PageNotFound',
};
</script>